@if (!formWorking()) {
  <div class="container">
    <form [formGroup]="form">
      <div class="facility-info">
        <div class="facility-name">
          <label for="facilityName"
            >{{ 'LOCATION.LABEL.FACILITY_NAME' | translate }}:</label
          >
          <input type="text" pInputText formControlName="facilityName" />
        </div>
        <div class="facility-id">
          <label for="facilityUid"
            >{{ 'LOCATION.LABEL.FACILITY_UID' | translate }}:</label
          >
          <input type="text" pInputText formControlName="facilityUid" />
        </div>
      </div>
      @if (showNotes) {
        <div class="facility-notes">
          <label for="facilityNotes"
            >{{ 'LOCATION.LABEL.NOTES' | translate }}:</label
          >
          <textarea
            pTextarea
            autoResize="autoResize"
            formControlName="facilityNotes"
          ></textarea>
        </div>
      }
      @if (showNotepadEntries) {
        <div class="form-item">
          <label for="facilityNotes"
            >{{ 'LOCATION.LABEL.NOTEPAD_ENTRIES' | translate }}:</label
          >
          @for (entry of facilityNotepadEntries(); track entry.id) {
            <app-log-entry [entry]="entry" />
          }
        </div>
      }
    </form>
  </div>
}
